import type { FC } from 'react';
import React from 'react';
import { useTranslation } from '@lt/localization';
import Icon from 'src/components/Icon';
import PackageInfoItem from '../components/PackageInfoItem';

import type { IPackageMedInsuranceInfo } from '../types';

const MED_INSURANCE_ICON = <Icon type="garranty" />;

const getText = (
  included: boolean,
  isFetching: boolean,
  t: any,
): string | null => {
  if (isFetching) {
    return t('checkout.packageInfo.medInsurance.fetching');
  }
  if (included) {
    return t('checkout.packageInfo.medInsurance.include');
  }

  return null;
};

const PackageMedInsuranceInfo: FC<IPackageMedInsuranceInfo> = ({
  included = false,
  isFetching = false,
  isMobile,
}) => {
  const { t } = useTranslation();

  return (
    <PackageInfoItem
      icon={MED_INSURANCE_ICON}
      text={getText(included, isFetching, t)}
      isMobile={isMobile}
      hasError={!included}
    >
      {!included && (
        <span className="text">
          {t('checkout.packageInfo.medInsurance.noInclude')}
        </span>
      )}
    </PackageInfoItem>
  );
};

export default PackageMedInsuranceInfo;
